<template>
  <svg
    class="shrink-0"
    style=""
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0079 7.49089L12.5079 4.99089M2.91621 17.0826C3.60788 17.7742 4.72454 17.7742 5.41621 17.0826L16.2495 6.24922C16.9412 5.55755 16.9412 4.44089 16.2495 3.74922C15.5579 3.05755 14.4412 3.05755 13.7495 3.74922L2.91621 14.5826C2.22454 15.2742 2.22454 16.3909 2.91621 17.0826Z"
      :stroke="` ${color ? color : '#5138ee'}`"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.08333 2.03464L8.33333 1.66797L7.96667 2.91797L8.33333 4.16797L7.08333 3.8013L5.83333 4.16797L6.2 2.91797L5.83333 1.66797L7.08333 2.03464ZM3.75 7.03464L5 6.66797L4.63333 7.91797L5 9.16797L3.75 8.8013L2.5 9.16797L2.86667 7.91797L2.5 6.66797L3.75 7.03464ZM16.25 11.2013L17.5 10.8346L17.1333 12.0846L17.5 13.3346L16.25 12.968L15 13.3346L15.3667 12.0846L15 10.8346L16.25 11.2013Z"
      :stroke="` ${color ? color : '#5138ee'}`"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconPencilSparkle'
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) color!: String;
  @Prop({ default: '20' }) width!: string
  @Prop({ default: '20' }) height!: string
  @Prop({ default: '1.5' }) strokeWidth!: string
}
</script>

<style scoped>
</style>
